import { createRouter } from "@/lib/router/router";
import * as Sentry from "@sentry/vue";
import { createHead } from "@unhead/vue/client";
import { createPinia } from "pinia";
import { createApp } from "vue";
import App from "./App.vue";

import "./Colors.scss";
import "./Easings.scss";
import "./Fonts.scss";
import "./Global.scss";
import "./Themes.scss";
import "./Transitions.scss";

const app = createApp(App);

Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  sendDefaultPii: true,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
    }),
  ],
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 0.1,
});

app
  .use(createPinia())
  .use(createRouter())
  .use(createHead())
  .mount("body");
